/* novicoo — global.js */
(function () {
  'use strict';

  /* ---------- Collection filters ---------- */
  var filterForm = document.getElementById('FilterForm');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      // auto-apply on checkbox / radio / select; price fields use the Go button
      if (e.target.matches('input[type="checkbox"], input[type="radio"], select')) {
        filterForm.submit();
      }
    });
  }
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect && filterForm) {
    sortSelect.addEventListener('change', function () { filterForm.submit(); });
  }

  var sidebar = document.querySelector('[data-collection-sidebar]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-toggle]')) {
      if (sidebar) sidebar.classList.toggle('is-open');
      return;
    }
    if (sidebar && sidebar.classList.contains('is-open') &&
        !e.target.closest('[data-collection-sidebar]')) {
      sidebar.classList.remove('is-open');
    }
  });

  /* ---------- Helpers ---------- */
  function formatMoney(cents) {
    var format = window.moneyFormat || '€{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Header search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-header-search]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) searchBar.querySelector('input[type="search"], input[name="q"]').focus();
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function refreshCart() {
    return fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  function renderDrawer(cart) {
    var body = drawer && drawer.querySelector('[data-cart-drawer-body]');
    var footer = drawer && drawer.querySelector('[data-cart-drawer-footer]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
          '<p class="cart-drawer__empty-title">Your cart is empty</p>' +
          '<p class="cart-drawer__empty-sub">Add some tech and it will show up here.</p>' +
          '<a class="btn btn--primary btn--pill" href="/collections/all">Start shopping</a>' +
        '</div>';
      if (footer) footer.hidden = true;
      return;
    }

    var html = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">'
        : '';
      return (
        '<div class="cart-drawer__item" data-line-key="' + item.key + '">' +
          '<div class="cart-drawer__item-media">' + img + '</div>' +
          '<div class="cart-drawer__item-info">' +
            '<a class="cart-drawer__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
            (item.variant_title ? '<div class="cart-drawer__item-price">' + item.variant_title + '</div>' : '') +
            '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-drawer__item-qty">' +
              '<div class="qty-input">' +
                '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-value readonly>' +
                '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-line-remove>Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    body.innerHTML = html;
    if (footer) {
      footer.hidden = false;
      var subtotal = footer.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
    }
    updateFreeShipping(cart);
  }

  function updateFreeShipping(cart) {
    var bar = drawer && drawer.querySelector('[data-freeship]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    if (threshold <= 0) { bar.hidden = true; return; }
    bar.hidden = false;
    var subtotal = cart.items_subtotal_price;
    var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    var fill = bar.querySelector('[data-freeship-fill]');
    var msg = bar.querySelector('[data-freeship-msg]');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (subtotal >= threshold) {
        msg.innerHTML = '🎉 You have unlocked <strong>free shipping!</strong>';
        bar.classList.add('is-complete');
      } else {
        msg.innerHTML = 'You are <strong>' + formatMoney(threshold - subtotal) + '</strong> away from free shipping';
        bar.classList.remove('is-complete');
      }
    }
  }

  function changeLine(key, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var lineEl = e.target.closest('[data-line-key]');
    if (!lineEl) return;
    var key = lineEl.getAttribute('data-line-key');
    var qtyInput = lineEl.querySelector('[data-qty-value]');

    if (e.target.closest('[data-qty-change]')) {
      var delta = parseInt(e.target.closest('[data-qty-change]').getAttribute('data-qty-change'), 10);
      var next = Math.max(0, parseInt(qtyInput.value, 10) + delta);
      changeLine(key, next);
    }
    if (e.target.closest('[data-line-remove]')) {
      changeLine(key, 0);
    }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var sku = form.getAttribute('data-sku') || '';

    // live supplier stock pre-check (no-op until the stock API is configured)
    var precheck = (window.novicooVerifyStock && sku)
      ? window.novicooVerifyStock([{ sku: sku, qty: qty }])
      : Promise.resolve({ ok: true });

    precheck
      .then(function (check) {
        if (!check.ok) {
          var info = check.items && check.items[sku];
          var left = info && info.available != null ? info.available : 0;
          alert('Sorry — only ' + left + ' left in stock for this item.');
          return null;
        }
        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () { return refreshCart(); })
          .then(function () { openDrawer(); });
      })
      .catch(function (err) {
        alert((err && err.description) || 'Could not add to cart.');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (!stepBtn || e.target.closest('[data-line-key]')) return;
    var wrap = stepBtn.closest('.qty-input');
    var input = wrap.querySelector('input');
    var delta = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    var main = gallery.querySelector('[data-gallery-main] img');
    main.src = thumb.getAttribute('data-image-src');
    main.srcset = '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* ---------- Variant selection: update price / availability ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    var productJsonEl = document.querySelector('[data-product-json="' + form.getAttribute('data-product-id') + '"]');
    if (!productJsonEl) return;
    var product = JSON.parse(productJsonEl.textContent);

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-select]')) return;
      var selected = Array.from(form.querySelectorAll('[data-option-select]')).map(function (s) { return s.value; });
      var variant = product.variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[type="submit"]');
      var priceEl = document.querySelector('[data-product-price]');
      if (variant) {
        idInput.value = variant.id;
        form.setAttribute('data-sku', variant.sku || '');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? btn.getAttribute('data-atc-text') : 'Sold out';
        }
      } else if (btn) {
        btn.disabled = true;
        btn.textContent = 'Unavailable';
      }
    });
  });

  /* ---------- Initial cart count ---------- */
  refreshCart();
})();

/* ---------- Predictive search (suggestions while typing) ---------- */
(function () {
  'use strict';

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  document.querySelectorAll('.header-searchbar, .header-search form').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var box = document.createElement('div');
    box.className = 'predictive';
    box.hidden = true;
    form.appendChild(box);

    var timer = null;
    var lastQuery = '';

    function close() { box.hidden = true; box.innerHTML = ''; }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        lastQuery = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (q !== lastQuery) return;   // stale response
            var items = (((d || {}).resources || {}).results || {}).products || [];
            if (!items.length) {
              box.innerHTML = '<div class="predictive__empty">No products found for “' + esc(q) + '”</div>';
              box.hidden = false;
              return;
            }
            box.innerHTML = items.map(function (p) {
              var imgUrl = (p.featured_image && p.featured_image.url) || p.image || '';
              var img = imgUrl ? '<img src="' + esc(imgUrl) + '" alt="" loading="lazy" width="42" height="42">' : '';
              var price = p.price ? '<span class="predictive__price">€' + esc(p.price) + '</span>' : '';
              return '<a class="predictive__item" href="' + esc(p.url) + '">' + img +
                     '<span class="predictive__title">' + esc(p.title) + '</span>' + price + '</a>';
            }).join('') +
            '<a class="predictive__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results &rarr;</a>';
            box.hidden = false;
          })
          .catch(close);
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  });
})();

/* ---------- Live supplier stock verification ---------- */
(function () {
  'use strict';

  /**
   * Verify requested quantities against the supplier stock proxy.
   * items: [{ sku, qty }]  ->  Promise<{ ok, items: { SKU: {requested, available, ok} } }>
   * Fails OPEN (ok:true) when the API is not configured, times out, or errors.
   */
  window.novicooVerifyStock = function (items) {
    var api = (window.stockApi || '').replace(/\/+$/, '');
    items = (items || []).filter(function (it) { return it && it.sku; });
    if (!api || !items.length) return Promise.resolve({ ok: true, items: {} });

    var param = items.map(function (it) { return it.sku + ':' + (it.qty || 1); }).join(',');
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 4000) : null;

    return fetch(api + '/stock?items=' + encodeURIComponent(param), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && typeof d.ok === 'boolean') ? d : { ok: true, items: {} }; })
      .catch(function () { return { ok: true, items: {} }; })
      .finally(function () { if (timer) clearTimeout(timer); });
  };

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function proceed(form) {
    form.dataset.stockOk = '1';
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
    form.appendChild(h);
    form.submit();
  }

  function showMsg(form, res, cart) {
    var msg = form.querySelector('.stock-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'stock-msg';
      form.insertBefore(msg, form.firstChild);
    }
    var lines = [];
    Object.keys(res.items || {}).forEach(function (sku) {
      var it = res.items[sku];
      if (it.ok) return;
      var line = null;
      (cart.items || []).forEach(function (ci) { if (ci.sku === sku) line = ci; });
      var title = line ? line.product_title : sku;
      lines.push('<li><strong>' + esc(title) + '</strong> — only ' +
        (it.available == null ? 0 : it.available) + ' left in stock (you have ' + it.requested + ')</li>');
    });
    msg.innerHTML = '<p><strong>Some items exceed available stock:</strong></p><ul>' +
      lines.join('') + '</ul><p>Please adjust the quantities and try again.</p>';
    msg.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"]');
    if (!btn) return;
    if (!(window.stockApi || '')) return;                    // feature off
    var form = btn.closest('form');
    if (!form || form.dataset.stockOk === '1') return;       // already verified

    e.preventDefault();
    var original = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Checking stock…';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || [])
          .filter(function (it) { return it.sku; })
          .map(function (it) { return { sku: it.sku, qty: it.quantity }; });
        return window.novicooVerifyStock(items).then(function (res) {
          btn.disabled = false; btn.innerHTML = original;
          if (res.ok) { proceed(form); } else { showMsg(form, res, cart); }
        });
      })
      .catch(function () {                                    // never block on our own failure
        btn.disabled = false; btn.innerHTML = original;
        proceed(form);
      });
  });
})();

/* ---------- Mobile nav accordion ---------- */
(function () {
  'use strict';
  var nav = document.querySelector('.mobile-nav');
  if (!nav) return;

  function addToggle(container, submenu) {
    container.classList.add('has-sub');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mnav-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Expand submenu');
    btn.innerHTML = '<span class="nav-chev" aria-hidden="true"></span>';
    container.insertBefore(btn, submenu);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = container.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // any list item with a nested list or mega panel becomes collapsible
  nav.querySelectorAll('ul > li').forEach(function (li) {
    var sub = li.querySelector(':scope > ul, :scope > .mega');
    if (sub) addToggle(li, sub);
  });
  // level-2 sections inside the mega tree collapse too
  nav.querySelectorAll('.mega__block').forEach(function (block) {
    var list = block.querySelector(':scope > .mega__list');
    if (list) addToggle(block, list);
  });
})();